import styled, { css } from 'styled-components'

export const WalletSettingsContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding: ${theme.spacings.large};
    text-align: center;
  `}
`

export const WalletSettingsFields = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.outlineGray};
    border-radius: ${theme.border.radius.medium};
    margin-top: ${theme.spacings.medium};
    text-align: left;
  `}
`

export const WalletSettingsField = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.small} ${theme.spacings.medium};

    &:first-child {
      border-bottom: 1px solid ${theme.colors.outlineGray};
    }

    &:nth-child(3) {
      padding-top: 0;
    }
  `}
`

export const WalletSettingsFooter = styled.footer`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: ${theme.spacings.medium};
    padding: ${theme.spacings.xsmall} ${theme.spacings.small};

    position: absolute;
    bottom: 0;
    left: 0;
  `}
`
